/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, Table, Empty, Popconfirm, message, DatePicker } from 'antd'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { Query, graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { RoleCode } from '../../constants'

import AddForm from './addForm'
import ViewDetails from './viewDetails'
import UserName from '../../components/Custom/UserNameLabel'

const { MonthPicker } = DatePicker

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			page: 1,
			pageSize: 10,
			searchText: '',
			sortOrder: null,
			sortName: null,
			isAddFormShown: false,
			isEdit: false,
			selectedComplain: null,
			complain_status: [],
			isViewDetailShown: false,
			selectedComplainUid: null,
			selectedMonth: null
		}
        
		this.handleOnChange = this.handleOnChange.bind(this)
	}
    
	handleOnChange(pagination, filters, sorter) {
		this.setState({
			page: pagination.current,
			pageSize: pagination.pageSize,
			sortOrder: (sorter.order === 'ascend') ? 'asc' : 'desc',
			sortName: sorter.field,
			complain_status: filters.status,
		})
	}

	render() {
		const { AuthStore } = this.props
		const { barangay_uid, barangay_term_uid, user_type } = AuthStore
		const isAdmin = _.isEqual(RoleCode.SUPERADMIN, user_type) || _.isEqual(RoleCode.SYSTEMADMIN, user_type)
		const { page, pageSize, sortOrder, sortName, searchText,
			isAddFormShown, isEdit, selectedComplain, complain_status = [],
			isViewDetailShown, selectedComplainUid, selectedMonth
		} = this.state
		const filters = { 
			page, pageSize, searchText, sortOrder, sortName,
			complain_status, 
			month_selected: selectedMonth ? moment(selectedMonth).format('YYYY-MM') : null
		}

		const statusFilter = [{ text: 'Pending', value: 'Pending' },
			{ text: 'On-Going', value: 'On-Going' },
			{ text: 'File to Action', value: 'File to Action' },
			{ text: 'Settled', value: 'Settled' },
			{ text: 'Referral', value: 'Referral' }]
		
		return (
			<Row type='flex' justify='center'>
				<Col md={24} sm={24}>
					{
						!barangay_term_uid &&
						<div className="alert alert-icon alert-danger alert-dismissible fade show" role="alert">
							<i className="mdi mdi-block-helper mr-2"></i>
							<strong>Warning!</strong>  Barangay Term not defined in the system, please check your setup in Utilities > Data Lookup Management module.
						</div>
					}
					<Row>
						{
							isAdmin &&
							<MonthPicker
								format='MMMM YYYY'
								style={{ marginRight: 20, marginTop: 5, width: 200, float: 'left' }}
								onChange={(value) => {
									this.setState({ selectedMonth: value })
								}}
							/>
						}
						<button 
							type="button" 
							className="btn btn-outline-success btn-rounded waves-effect waves-light"
							onClick={() => {
								if (!selectedMonth) return message.error('Select Month that you want to export.')
								const { generateReport } = this.props
								const params = {
									barangay_uid,
									month_selected: moment(selectedMonth).format('YYYY-MM'),
									searchText
								}
								generateReport(params)
									.then((response) => {
										const { file_url } = response.data.generateReport
										window.open(`${process.env.REACT_APP_BACKEND_API}${file_url}`, '_blank')
									})
									.catch(err => {
										console.log('error generating kp report', err)
										message.error('Error generating report')
									})
							}}
						>
							<i className='mdi mdi-file-excel'/> Export in Excel
						</button>
						{
							barangay_term_uid &&
							<button type="button" className="btn btn-primary btn-rounded waves-effect waves-light" onClick={() => {
								this.setState({ isAddFormShown: true, isEdit: false, selectedComplain: null })
							}} style={{ float: 'right' }}>New Complaint</button>
						}
						<Input placeholder='Search Here' style={{ width: 230, float: 'right', marginRight: 20, marginTop: 5 }} onChange={(e) => {
							this.setState({ searchText: e.target.value })
						}}/>
					</Row>
					<br />
					<Row>
						<Query 
							query={BARANGAY_COMPLAINS} 
							variables={{ searchFilter: filters, barangay_uid }}
							fetchPolicy='network-only'
						>
							{({ loading, error, data }) => {
								if (error) return <Empty/>

								let barangayComplains = _.has(data,'barangayComplains') ? data.barangayComplains.data : []
								barangayComplains = barangayComplains.map((barangayComplain, key) => Object.assign({}, barangayComplain, { key }))
								let _pagination = _.has(data, 'barangayComplains') ? data.barangayComplains.pagination : {}
								_pagination = Object.assign({}, _pagination, {
									pageSizeOptions: ['10', '25', '50'],
									showSizeChanger: true,
									total: _.has(_pagination, 'rowCount') ? _pagination.rowCount : 0,
									showTotal: (total) => `Total ${total} items`
								})

								const columns = [{
									title: 'Case No.',
									key: 'case_no',
									width: 130,
									render: (record) => {
										return (
											<Link 
												// to={{ pathname: `/complains/details/${record.uid}`, state: { complain_uid: record.uid } }} 
												to={`/complains/details/${record.uid}`}
												style={{ marginRight: 10 }}
											>
												{record.case_no}
											</Link>
										)
									}
								}, {
									title: 'Complainant(s)',
									key: 'complainant_name',
									render: (record) => {
										const complainants = record.complainants.map(i => i.complainant_name).join(', ')
										return (
											<span>{complainants}</span>
										)
									}
								}, {
									title: 'Respondent(s)',
									key: 'respondent_name',
									render: (record) => {
										const respondents = record.respondents.map(i => i.respondent_name).join(', ')
										return (
											<span>{respondents}</span>
										)
									}
								}, {
									title: 'Status',
									key: 'status',
									//dataIndex: 'status',
									filters: statusFilter,
									render: (record) => {
										let badgeType = 'badge-primary'
										if (_.isEqual(record.status, 'Pending')) {
											badgeType = 'badge-info'
										} else if (_.isEqual(record.status, 'On-Going')) {
											badgeType = 'badge-warning'
										} else if (_.isEqual(record.status, 'File to Action')) {
											badgeType = 'badge-danger'
										} else if (_.isEqual(record.status, 'Settled')) {
											badgeType = 'badge-success'
										} else if (_.isEqual(record.status, 'Referral')) {
											badgeType = 'badge-purple'
										}
										return (
											<span className={`badge ${badgeType}`}>{record.status}</span>
										)
									}
								}, {
									title: 'Nature of Case',
									key: 'nature_of_case',
									dataIndex: 'nature_of_case'
								}, {
									title: 'Date Filed',
									key: 'complain_date',
									render: (record) => {
										return (
											<span>{moment(record.created_at).format('lll')}</span>
										)
									}
								}, {
									title: 'Created By',
									key: 'created_by',
									render: (record) => {
										return (
											<UserName user_uid={record.created_by}/>
										)
									}
								}, {
									title: 'Action',
									key: 'action',
									width: 200,
									render: (record) => {
										if (_.isEqual(record.status, 'Filed as blotter')) {
											return <i style={{ color: 'red' }}>Case moved in blotter</i>
										} else {
											return (
												<React.Fragment>
													<Link 
														// to={{ pathname: `/complains/details/${record.uid}`, state: { complain_uid: record.uid } }} 
														to={`/complains/details/${record.uid}`}
														style={{ marginRight: 10 }}
													>
														View Details
													</Link>
													{
														(!_.isEqual(record.status, 'Resolved') && !_.isEqual(record.status, 'File to Action')) &&
														<a href="#" style={{ marginRight: 10 }} onClick={() => this.setState({ isAddFormShown: true, isEdit: true, selectedComplain: record })}>Edit</a>
													}
													{
														isAdmin &&
														<Popconfirm
															title="Are you sure delete this complain?"
															onConfirm={() => {
																const { deleteComplain } = this.props
																deleteComplain({ complain_uid: record.uid })
																	.then((response) => {
																		message.success('Complain successfully deleted.')

																		//create audit trail
																		const auditParams = {
																			module_name: 'Complains',
																			action: 'Delete',
																			message: `Deleted complain case ${record.case_no}`
																		}
																		AuthStore.saveAuditTrail(auditParams)
																	}).catch(err => {
																		console.log('error deleting complain', err)
																		message.error(err.message.replace('GraphQL error:', ''))
																	})
															}}
															// onCancel={cancel}
															okText="Yes"
															cancelText="No"
														>
															<a href="javascript:void(0)" >Delete</a>
														</Popconfirm>
													}
												</React.Fragment>
											)
										}
									}
								}]
								return (
									<Table 
										loading={loading}
										columns={columns} 
										dataSource={barangayComplains} 
										bordered
										onChange={this.handleOnChange}
										pagination={_pagination}
										scroll={{ x: 1020 }}
									/>
								)
							}}
						</Query>
					</Row>
					{
						isAddFormShown &&
                        <AddForm
                        	isEdit={isEdit}
                        	selectedComplain={selectedComplain}
                        	visible={isAddFormShown}
                        	onClose={() => this.setState({ isAddFormShown: false, isEdit: false, selectedComplain: null })}
                        />
					}
					{
						isViewDetailShown &&
						<ViewDetails 
							complain_uid={selectedComplainUid}
							visible={isViewDetailShown}
							onCancel={() => this.setState({ isViewDetailShown: false, selectedComplainUid: null })}
						/>
					}
				</Col>
			</Row>
		)
	}
}

const BARANGAY_COMPLAINS = gql`
    query barangayComplains($barangay_uid: String, $searchFilter: SearchParams) {
		barangayComplains(barangay_uid: $barangay_uid, searchFilter: $searchFilter)
    }
`

const DELETE_COMPLAIN = gql`
    mutation deleteComplain($input: JSON) {
		deleteComplain(input: $input)
    }
`

const GENERATE_KP_REPORT = gql`
    mutation generateReport($input: JSON) {
		generateReport(input: $input)
    }
`

const composed = compose(
	inject('AuthStore'),
	graphql(DELETE_COMPLAIN, {
		props({ mutate }) {
			return {
				deleteComplain(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['barangayComplains']
					})
				}
			}
		}
	}),
	graphql(GENERATE_KP_REPORT, {
		props({ mutate }) {
			return {
				generateReport(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['barangayComplains']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
